import { cn } from "@/lib/utils";
import { Filter as FilterIcon } from "lucide-react";
import { memo } from "react";

export interface QueryTableFilteredSortedBadgeFilterSegmentProps {
  committedFilterCount: number;
  segmentMutedClassName: string;
}

const QueryTableFilteredSortedBadgeFilterSegmentComp = ({
  committedFilterCount,
  segmentMutedClassName,
}: QueryTableFilteredSortedBadgeFilterSegmentProps) => (
  <span
    className={cn(
      "inline-flex shrink-0 items-center gap-1",
      segmentMutedClassName,
    )}
  >
    <FilterIcon className="size-3.5 shrink-0" />
    {committedFilterCount > 0 ? (
      <span className="min-w-[1ch] font-medium tabular-nums">
        {committedFilterCount}
      </span>
    ) : null}
  </span>
);

export const QueryTableFilteredSortedBadgeFilterSegment = memo(
  QueryTableFilteredSortedBadgeFilterSegmentComp,
);
